<template>
  <router-view> </router-view>
</template>
<script>
import { hideLoading } from '../services/loading.service';
import pvTrack from '@/services/pvtrack.service';
export default {
  mounted() {
    hideLoading();
    pvTrack.start(
        {
          dealerId: 0,
          dealerInfoId: 0,
          source: '',
          cityId: 0
        }
      );
  },
};
</script>
